import globalApi from '@/request/globalApi/globalApi'

const END_POINT = 'api/rights'

// eslint-disable-next-line import/prefer-default-export
export const fetchAllRightsRequest = () => globalApi.get(END_POINT)
